webpackJsonp([149],{

/***/ 2558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel2_vue__ = __webpack_require__(3167);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_681f3a61_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Carousel2_vue__ = __webpack_require__(3680);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3672)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-681f3a61"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_681f3a61_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Carousel2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/carousel/Carousel2.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-681f3a61", Component.options)
  } else {
    hotAPI.reload("data-v-681f3a61", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import NeuCardFunctions from '../ui/NeuCardFunctions.vue'
// import NeuCardFunctionsBigText from '../ui/NeuCardFunctionsBigText.vue'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    // NeuCardFunctions,
    // NeuCardFunctionsBigText,
    'neu-card-function': function neuCardFunction() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 2430));
    },
    'neu-card-general': function neuCardGeneral() {
      return __webpack_require__.e/* import() */(121/* duplicate */).then(__webpack_require__.bind(null, 2500));
    },
    'neu-card-big-text': function neuCardBigText() {
      return __webpack_require__.e/* import() */(122/* duplicate */).then(__webpack_require__.bind(null, 2546));
    }
  },
  data: function data() {
    return {
      index: 0,
      slides: [],
      slideDirection: ''
    };
  },

  computed: {
    slidesLength: function slidesLength() {
      return this.slides.length;
    }
  },
  props: {
    cards: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      require: false
    },
    iconColor: {
      type: String,
      required: false
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.initCarousel();
    });
  },

  methods: {
    initCarousel: function initCarousel() {
      var prev = document.querySelector('.prev');
      var next = document.querySelector('.next');
      var track = document.querySelector('.track');
      var cardContainer = document.querySelector('.carousel-container');
      var cardLenght = this.cards.length - 1;
      // let carouselWidth = document.querySelector('.carousel-container').offsetWidth
      var cardWidth = document.querySelector('.card-container').offsetWidth;
      if (this.cards.length === 3) {
        next.classList.add('hide');
      }

      window.addEventListener('resize', function () {
        var cardContainer = document.querySelector('.card-container');
        if (cardContainer) {
          cardWidth = cardContainer.offsetWidth;
        }
      });
      var index = 0;
      prev.classList.add('hide');
      if (window.innerWidth <= 1052) {
        next.addEventListener('click', function () {
          index++;
          prev.classList.remove('hide');
          track.style.transform = 'translateX(-' + index * cardWidth + 'px)';
          if (index === cardLenght) {
            next.classList.add('hide');
          }
        });

        prev.addEventListener('click', function () {
          index--;
          next.classList.remove('hide');
          if (index === 0) {
            prev.classList.add('hide');
          }
          track.style.transform = 'translateX(-' + index * cardWidth + 'px)';
        });

        window.setInterval(function () {
          if (index < cardLenght) {
            index++;
            prev.classList.remove('hide');
            track.style.transform = 'translateX(-' + index * cardWidth + 'px)';
            if (index === cardLenght) {
              next.classList.add('hide');
            }
          } else if (index === cardLenght) {
            index = index - cardLenght;
            next.classList.add('hide');
            if (index === cardLenght) {
              prev.classList.remove('show');
              prev.classList.add('hide');
            }
            var i = -1;
            for (i = -1; i <= cardLenght; i++) {
              track.style.transform = 'translateX(-' + index * cardWidth + 'px)';
            }
            prev.classList.add('hide');
            next.classList.remove('hide');
          }
        }, 9999999999999);
      } else {
        var cardLenght2 = cardLenght;
        next.addEventListener('click', function () {
          index++;
          prev.classList.remove('hide');
          track.style.transform = 'translateX(-' + index * cardWidth + 'px)';
          if (track.offsetWidth - index * cardWidth < cardContainer.offsetWidth) {
            next.classList.add('hide');
          }
        });

        prev.addEventListener('click', function () {
          index--;
          next.classList.remove('hide');
          if (index === 0) {
            prev.classList.add('hide');
          }
          track.style.transform = 'translateX(-' + index * cardWidth + 'px)';
        });
        window.setInterval(function () {
          if (index < cardLenght2) {
            index++;
            prev.classList.add('show');
            track.style.transform = 'translateX(-' + index * cardWidth + 'px)';
            //  if (cardLenght2 <= 3) {
            // movement.style.transform = `translateX(${index * 42}rem)`
            // } else {
            // movement.style.transform = `translateX(${index * cardLenght2}rem)`
            // }
            if (track.offsetWidth - index * cardWidth < cardContainer.offsetWidth) {
              next.classList.add('hide');
            }
          }
          if (index === cardLenght2) {
            index = index - cardLenght2;
            next.classList.remove('hide');
            if (index === 0) {
              prev.classList.remove('show');
            }
            var i = -1;
            for (i; i <= cardLenght2; i++) {
              track.style.transform = 'translateX(-' + index * cardWidth + 'px)';
            }
          }
        }, 99999999997000);
      }
    }
  }
});

/***/ }),

/***/ 3672:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3673);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("0f7c5f0e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-681f3a61\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Carousel2.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-681f3a61\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Carousel2.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3673:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);", ""]);

// module
exports.push([module.i, "\n.overline-typescale[data-v-681f3a61]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-681f3a61],.slide-down-leave-active[data-v-681f3a61]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-681f3a61],.slide-down-leave-to[data-v-681f3a61]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-681f3a61],.slide-fade-left-leave-active[data-v-681f3a61]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-681f3a61],.slide-fade-left-leave-to[data-v-681f3a61]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-681f3a61]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-681f3a61],.fade-leave-to[data-v-681f3a61]{opacity:0\n}\n.carousel-container[data-v-681f3a61]{width:1280px;margin:-2rem auto 0 auto;min-height:200px;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n@media screen and (max-width: 768px){\n.carousel-container[data-v-681f3a61]{width:80%\n}\n}\n@media screen and (max-width: 1000px){\n.carousel-container[data-v-681f3a61]{width:100%\n}\n}\n@media screen and (min-width: 1001px) and (max-width: 1440px){\n.carousel-container[data-v-681f3a61]{width:85%\n}\n}\n.carousel-container .carousel-inner[data-v-681f3a61]{overflow:hidden;background-color:transparent\n}\n@media screen and (min-width: 1100px) and (max-width: 1281px){\n.carousel-container .carousel-inner[data-v-681f3a61]{width:113% !important\n}\n}\n@media screen and (max-width: 320px){\n.carousel-container .carousel-inner[data-v-681f3a61]{width:20rem\n}\n}\n@media screen and (min-width: 321px) and (max-width: 425px){\n.carousel-container .carousel-inner[data-v-681f3a61]{width:100%\n}\n}\n.carousel-container .track[data-v-681f3a61]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-transition:-webkit-transform 0.5s;transition:-webkit-transform 0.5s;transition:transform 0.5s;transition:transform 0.5s, -webkit-transform 0.5s\n}\n.carousel-container .card-container[data-v-681f3a61]{-ms-flex-negative:0;flex-shrink:0;overflow:initial;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n@media only screen and (min-width: 1024px) and (min-width: 1281px) and (max-width: 1324px){\n.carousel-container .card-container[data-v-681f3a61]{padding-top:5rem;padding-right:4rem;padding-left:4rem;padding-bottom:3rem;width:30rem\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 1324px) and (max-width: 1452px){\n.carousel-container .card-container[data-v-681f3a61]{padding-top:5rem;padding-right:3rem;padding-left:5rem;padding-bottom:3rem;width:30rem\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 1452px){\n.carousel-container .card-container[data-v-681f3a61]{padding-top:5rem;padding-right:5rem;padding-left:5rem;padding-bottom:3rem;width:30rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape) and (min-width: 1024px) and (max-width: 1062px){\n.carousel-container .card-container[data-v-681f3a61]{padding-top:4rem;padding-right:3rem;padding-left:3rem;padding-bottom:3rem;width:25rem;height:38rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape) and (min-width: 1063px) and (max-width: 1130px){\n.carousel-container .card-container[data-v-681f3a61]{padding-top:4rem;padding-right:3rem;padding-left:3rem;padding-bottom:3rem;width:27rem;height:38rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape) and (min-width: 1131px) and (max-width: 1281px){\n.carousel-container .card-container[data-v-681f3a61]{padding-top:4rem;padding-right:3rem;padding-left:3rem;padding-bottom:3rem;width:27rem;height:38rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 768px) and (max-width: 814px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 768px) and (max-width: 814px){\n.carousel-container .card-container[data-v-681f3a61]{padding-top:4rem;padding-right:5rem;padding-left:5rem;padding-bottom:5rem;width:35rem;height:38rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 815px) and (max-width: 1024px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 815px) and (max-width: 1024px){\n.carousel-container .card-container[data-v-681f3a61]{padding-top:5rem;padding-right:2rem;padding-left:1rem;padding-bottom:2rem;width:23rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 321px) and (max-width: 375px){\n.carousel-container .card-container[data-v-681f3a61]{padding-top:5rem;padding-right:16rem;padding-bottom:2rem;width:33rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 376px) and (max-width: 425px){\n.carousel-container .card-container[data-v-681f3a61]{padding-top:5rem;padding-right:16rem;padding-bottom:2rem;padding-left:1rem;width:37rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 426px) and (max-width: 565px){\n.carousel-container .card-container[data-v-681f3a61]{padding-top:5rem;padding-right:15rem;padding-left:3rem;padding-bottom:2rem;width:37rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 566px) and (max-width: 768px){\n.carousel-container .card-container[data-v-681f3a61]{padding-top:5rem;padding-right:11rem;padding-left:4rem;padding-bottom:2rem;width:37rem\n}\n}\n@media only screen and (max-width: 575px) and (max-width: 320px){\n.carousel-container .card-container[data-v-681f3a61]{padding-top:5rem;padding-right:16rem;padding-bottom:2rem;width:32rem\n}\n}\n.carousel-container .card-container .card[data-v-681f3a61]{width:100%;height:100%;border:1px solid #ccc;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:10px;display:contents;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n.nav[data-v-681f3a61]{width:50%;top:50%;position:absolute\n}\n.nav button[data-v-681f3a61]{border-radius:50%;border:1px solid #aaa;position:absolute;background-color:transparent;-webkit-transform:translateY(-50%);transform:translateY(-50%);cursor:pointer\n}\n.nav .prev[data-v-681f3a61]{right:100%\n}\n.nav .prev.show[data-v-681f3a61]{display:block\n}\n.nav .next[data-v-681f3a61]{left:200%\n}\n.nav .next.hide[data-v-681f3a61]{display:none\n}\n.nav .prev.hide[data-v-681f3a61]{display:none\n}\n.button-line[data-v-681f3a61]{position:relative;border-top:1px solid black;vertical-align:bottom;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n@media only screen and (min-width: 1024px){\n.button-line[data-v-681f3a61]{margin-top:4rem\n}\n}\n.card>*[data-v-681f3a61]{-webkit-box-flex:1;-ms-flex:1;flex:1\n}\n.card .img[data-v-681f3a61]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:30px\n}\n.card .info[data-v-681f3a61]{-ms-flex-preferred-size:40px;flex-basis:40px;background:#333;color:#fff;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;padding:10px;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n", ""]);

// exports


/***/ }),

/***/ 3680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "carousel-container" }, [
    _c("div", { staticClass: "carousel-inner centered" }, [
      _c(
        "div",
        { staticClass: "track centered" },
        _vm._l(_vm.cards, function(card) {
          return _c(
            "div",
            { key: _vm.cards[card], staticClass: "card-container centered" },
            [
              _c("neu-card-general", {
                attrs: {
                  "data-index": _vm.index,
                  src: card.src,
                  link: card.link,
                  title: card.title,
                  subtitle: card.subtitle,
                  titleLines: card.titleLines,
                  subtitleLines: card.subtitleLines,
                  iconColor: _vm.iconColor
                }
              })
            ],
            1
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "nav centered" }, [
      _c(
        "button",
        {
          staticClass: "prev",
          staticStyle: {
            "background-color": "transparent",
            "border-color": "transparent",
            transform: "rotate(-180deg)"
          }
        },
        [
          _c(
            "i",
            { staticClass: "prev" },
            [
              _c("base-icon", {
                staticClass: "prev",
                attrs: {
                  width: "30",
                  height: "30",
                  src: "/static-appopensalud/img/icons/noun-arrow-blue.svg",
                  color: _vm.iconColor
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "next",
          staticStyle: {
            "background-color": "transparent",
            "border-color": "transparent",
            transform: "rotate(-0deg)"
          }
        },
        [
          _c(
            "i",
            { staticClass: "next" },
            [
              _c("base-icon", {
                staticClass: "next",
                attrs: {
                  width: "30",
                  height: "30",
                  src: "/static-appopensalud/img/icons/noun-arrow-blue.svg",
                  color: _vm.iconColor
                }
              })
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-681f3a61", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/149.ab1496c2b49e7fee7f8f.js